/* eslint-disable */
import { wrapRootElement } from "@tmu/apollo/wrapRootElement"

export { wrapRootElement }
